/**
 *
 * @param {import('../reducers/dashboardReducer').TDataDashboard} dashboardData
 * @returns {import('redux').AnyAction}
 */
export function setDashboardData(dashboardData) {
  return {
    type: 'SET_DASHBOARD_DATA',
    payload: {
      dashboardData,
    },
  };
}

/**
 * @typedef {import('../reducers/dashboardReducer').TStoreSliceOfDashboard['viewParams']} TViewParams
 * @param {Partial<TViewParams>} viewParams
 */
export function filterDashboardData(viewParams) {
  return {
    type: 'SET_DASHBOARD_VIEW_PARAMS',
    payload: {
      ...viewParams,
    },
  };
}

export function clearFilters() {
  return {
    type: 'CLEAR_FILTERS',
    payload: {},
  };
}
